export default __webpack_public_path__ + "static/media/menu-vip-logo-diamond.8eea054a.webp";